import React from 'react';
import ItemEditForm from './ItemEditForm';

const ItemModal = ({
  isOpen,
  mode,
  selectedItem,
  formData,
  categories,
  isAdmin,
  showDeleteConfirm,
  duplicateToast,
  existingBarcodes,
  onClose,
  onSubmit,
  onSaveAndDuplicate,
  onInputChange,
  onEdit,
  onDelete,
  onConfirmDelete,
  onCancelDelete
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            {mode === 'view' && 'Item Details'}
            {mode === 'add' && 'Add New Item'}
            {mode === 'edit' && 'Edit Item'}
            {mode === 'duplicate' && 'Duplicate Item'}
          </h2>
          <button className="close-btn" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          {mode === 'view' ? (
            <ViewMode
              item={selectedItem}
              isAdmin={isAdmin}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ) : (
            <ItemEditForm
              formData={formData}
              categories={categories}
              mode={mode}
              duplicateToast={duplicateToast}
              existingBarcodes={existingBarcodes}
              onSubmit={onSubmit}
              onSaveAndDuplicate={onSaveAndDuplicate}
              onInputChange={onInputChange}
              onClose={onClose}
              onDelete={onDelete}
            />
          )}
        </div>

        {showDeleteConfirm && (
          <div className="delete-confirm-overlay">
            <div className="delete-confirm-dialog">
              <h3>Delete Item?</h3>
              <p>
                Are you sure you want to delete "{selectedItem?.name}"?
              </p>
              <p className="warning-text">
                This action cannot be undone.
              </p>
              <div className="delete-confirm-actions">
                <button className="cancel-btn" onClick={onCancelDelete}>
                  Cancel
                </button>
                <button
                  className="confirm-delete-btn"
                  onClick={onConfirmDelete}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const ViewMode = ({ item, isAdmin, onEdit, onDelete }) => (
  <div className="item-details">
    <DetailRow label="Part Number" value={item?.part_number} />
    <DetailRow label="Name" value={item?.name} />
    <DetailRow label="Category" value={item?.category_name || '-'} />
    <DetailRow
      label="Barcode"
      value={item?.barcode}
      className="barcode"
    />
    <DetailRow
      label="Country of Origin"
      value={item?.country_of_origin || '-'}
    />
    <DetailRow label="Type" value={item?.raw_baked || '-'} />
    <DetailRow
      label="Weight Per Piece"
      value={item?.weight_per_piece ? `${item.weight_per_piece}g` : '-'}
    />
    <DetailRow label="Qty in Case" value={item?.qty_per_case || '-'} />
    <DetailRow
      label="Case Weight"
      value={item?.case_weight ? `${item.case_weight}kg` : '-'}
    />
    <DetailRow label="FDA Code" value={item?.fda_code || '-'} />
    <DetailRow
      label="Tariff Number"
      value={item?.tariff_number || '-'}
    />
    <DetailRow label="USMCA" value={item?.usmca || '-'} />
    <DetailRow
      label="Butter Fat %"
      value={item?.butter_fat_pct ? `${item.butter_fat_pct}%` : '-'}
    />
    <DetailRow
      label="Sugar %"
      value={item?.sugar_pct ? `${item.sugar_pct}%` : '-'}
    />
    <DetailRow
      label="Cocoa %"
      value={item?.cocoa_pct ? `${item.cocoa_pct}%` : '-'}
    />
    <div className="view-actions">
      {isAdmin && (
        <>
          <button
            className="action-btn edit"
            onClick={() => onEdit(item)}
          >
            Edit
          </button>
          <button className="action-btn delete" onClick={onDelete}>
            Delete
          </button>
        </>
      )}
    </div>
  </div>
);

const DetailRow = ({ label, value, className }) => (
  <div className="detail-row">
    <span className="label">{label}:</span>
    <span className={`value ${className || ''}`}>{value}</span>
  </div>
);

export default ItemModal;
